import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import * as serviceWorker from "@/serviceWorker";

import store from '@/store/store';
import App from "@/views/App"; 
// eslint-disable-next-line
import main from "@/styles/main.scss"

const root = createRoot(document.getElementById("root"));
root.render(
	<Provider store={ store }>
		<Router>
			<App />
		</Router>
	</Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
